<script setup lang="ts">
import type { CrystallizeImageProps } from "@aschehoug/crystallize-utils"
import { CrystallizeImage } from "@aschehoug/crystallize-utils"

const props = defineProps <{
  product?: CrystallizeProductIdentifier
} & Omit<CrystallizeImageProps, "image">>()

const { data, suspense } = useEcommerceCatalogue()

await suspense()

const image = computed(() => {
  const ean = getEan(props.product)
  if (!ean) {
    return undefined
  }

  return data.value?.get(ean)?.firstImage
})
</script>

<template>
  <CrystallizeImage
    v-if="image"
    v-bind="props"
    :image="image"
  />
</template>
